import { render, staticRenderFns } from "./AnnualCompaniesTransactions.vue?vue&type=template&id=1ca8ea6f"
import script from "./AnnualCompaniesTransactions.vue?vue&type=script&lang=js"
export * from "./AnnualCompaniesTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports